import { RoleType } from './RoleType'

export type RoleProps = {
  internalOnly: boolean
  partnerId?: string
}

export const determineRoleType = (role: RoleProps) => {
  //checks if its Instacart managed
  if (role.internalOnly) return RoleType.InstacartInternal
  //checks if the retailer created it
  if (role.partnerId != null) return RoleType.Custom
  //otherwise its one of the Instacart managed roles
  return RoleType.Default
}
